import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { IContextService, DomainContext, IStorageService, AccountContextValue, UserContext} from '@pershing/pershing-core';

@Injectable()
export class NxiContextService implements IContextService {
    selectedDomainContext$: Observable<DomainContext<any>>;
    selectedOrgContext$: Observable<any>;
    error$: Observable<any>;
    _error: BehaviorSubject<any>;
    defaultContext: DomainContext<any> = {
        domain: null,
        value: null
    };
    hasError: boolean;
    private gotoParam: any;
    _selectedDomainBehavior: BehaviorSubject<DomainContext<any>>;
    private dataStore: {
        selectedDomainContext: DomainContext<any>;
    };
    constructor(private storageService: IStorageService) {
        this._selectedDomainBehavior = new BehaviorSubject<any>('');
        this.selectedDomainContext$ = this._selectedDomainBehavior.asObservable();
        this._error = new BehaviorSubject<any>('');
        this.error$ = this._error.asObservable();
        console.log('in context constructor');
        this.loadLocalStorage();
    }
    setDomainContext(domain: string, value: any): void {
        console.log('value in setDomaincontext===========' + value);
        this.dataStore.selectedDomainContext = value;
        this._selectedDomainBehavior.next(value);
    }
    setGotoContext(goToContext: any) {
        this.setRouteContext(goToContext);
    }
    getGotoContext() {
        return this.getRouteContext();
    }
    setOrgDomainContext(domain: string, value: any): void { }
    clearContextError(): any { }
    getDeviceType(): any { }
    clearContext(): void { }
    setUserContext(userContext: UserContext) { }
    getUserContext() { }

    loadLocalStorage(): void {

        // fetching dataStore from LocalStorage.
        let localStorageValue = this.storageService.getItem('dataStore');
        if (localStorageValue !== null && localStorageValue !== undefined) {
            this.storageService.removeItem('dataStore');
            this.dataStore = (JSON.parse(localStorageValue));
            // Emits the context domain from localStorage
            if (this.dataStore.selectedDomainContext && this.dataStore.selectedDomainContext !== null) {
                this._selectedDomainBehavior = new BehaviorSubject(this.dataStore.selectedDomainContext);
                this.selectedDomainContext$ = this._selectedDomainBehavior.asObservable();
                let domainContext: any = this.dataStore.selectedDomainContext.domain;
                if (domainContext === 'account') {
                    let accountContextValue: any = this.dataStore.selectedDomainContext.value;
                    let domainValue: AccountContextValue = new AccountContextValue(accountContextValue.accountNumber, accountContextValue.shortName, accountContextValue.ibd,
                        accountContextValue.off, accountContextValue.ip, accountContextValue.categoryCode, accountContextValue.accountType, accountContextValue.status,
                        accountContextValue.custodianCode, accountContextValue.businessPurposeCode, accountContextValue.internalIdentifier, accountContextValue.isInternalCustody);
                    this.setDomainContext(domainContext, this.createDomainContext(domainContext, domainValue));
                } else {
                    this.dataStore.selectedDomainContext = null;
                    this._selectedDomainBehavior = new BehaviorSubject<DomainContext<any>>(this.defaultContext);
                    this.selectedDomainContext$ = this._selectedDomainBehavior.asObservable();
                }
            } else {
                this.dataStore.selectedDomainContext = null;
                this._selectedDomainBehavior = new BehaviorSubject<DomainContext<any>>(this.defaultContext);
                this.selectedDomainContext$ = this._selectedDomainBehavior.asObservable();
            }
        } else {
            this.dataStore = {
                selectedDomainContext: null
            };
            // Emits the default context domain -- account
            this._selectedDomainBehavior = new BehaviorSubject<DomainContext<any>>(this.defaultContext);
            this.selectedDomainContext$ = this._selectedDomainBehavior.asObservable();
        }
    }
    createAccountContext(value: any): DomainContext<AccountContextValue> {
        return { domain: 'account', value: <AccountContextValue>value };
    }
    createDomainContext(domain: string, value: any): DomainContext<any> {
        let domainContext: DomainContext<any>;
        if (domain === 'account') {
            domainContext = this.createAccountContext(value);
        }
        return domainContext;
    }
    saveLocalStorage(): void {
        if (this.dataStore && this.dataStore.selectedDomainContext) {
            if (this.dataStore && this.dataStore.selectedDomainContext.domain !== null && this.dataStore.selectedDomainContext.domain !== undefined
                && this.dataStore.selectedDomainContext.value !== null && this.dataStore.selectedDomainContext.value !== undefined) {
                this.storageService.setItem('dataStore', JSON.stringify(this.dataStore));
            }
        }
    }
    isAuthenticated(): boolean { return true; }
    setContextError(errorMessage: string, errorCode?: string): any { }
    setDeviceType(deviceType: string): any { }
    setRouteContext(routeContext: any) {
        this.gotoParam = routeContext;
    }
    getRouteContext() {
        return this.gotoParam;
    }
}
